import React from "react";
import { Navbar, Form, Nav, Button, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import Logo from "../assets/Doorstep_logo.png";

function Adminheader() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const admin = JSON.parse(sessionStorage.getItem("admin"));
  const profile = JSON.parse(sessionStorage.getItem("profile"));
  const apiURL = process.env.REACT_APP_API_URL;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const signout = () => {
    try {
      axios
        .get(`/api/signout/` + admin._id)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            sessionStorage.removeItem("admin");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("profile");
            alert("Signout Successfully");

            window.location.href = "/";
            return;
          } else {
            alert("Signout Unsuccessfully");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          alert("Signout Unsuccessfully");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Signout Unsuccessfully");
      // setdatacondition(true);
      return error;
    }
  };

  const profiledetails = () => {
    window.location.assign("/doctor/profile");
  };
  return (
    <Navbar
      dark
      expand="md"
      style={{
        backgroundColor: "#01a695",
        borderBottom: "1px solid hsla(0,0%,100%,.5)!important",
      }}
    >
      <Navbar.Brand href="/admins/dashboard">
        <img
          src={Logo}
          height="60px"
          width="60px"
          style={{
            marginTop: "-20px",
            marginBottom: "-20px",
            backgroundColor: "#01a695",
            marginLeft: "30px",
          }}
        />
        {/* <strong style={{ color: "blue", paddingLeft: "40px" }}>
          DoorStep Tuition
        </strong> */}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          {/* <Nav.Link href="/category/grocery" style={{color:"white"}}>Grocery</Nav.Link>                  
          <Nav.Link href="/category/grains" style={{color:"white"}}>Grains</Nav.Link> */}
          {/* {userdata!==null? <span> <Nav.Link href="/profile" style={{color:"white"}}>Profile</Nav.Link> </span>:<span></span>}  */}
          {/* {userdata!==null ? userdata.role !== 0?  <span> <Nav.Link href="/admin/dashboard" style={{color:"white",fontWeight:"700"}}>Admin Page</Nav.Link></span>:<span> <Nav.Link className="pr-3" href="/profile" style={{color:"white"}}><span class="material-icons" style={{fontSize:"32px"}}>account_circle</span></Nav.Link></span>:<span></span>}            */}
        </Nav>
        {userdata !== null ? (
          <span>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <Avatar
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/User_icon_2.svg/2048px-User_icon_2.svg.png"
                style={{ height: "30px", width: "30px" }}
                alt={profile ? profile.name : " "}
              />
            </IconButton>
            <Menu
              className="mt-5"
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {/* <MenuItem onClick={profiledetails}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My account</MenuItem> */}
              <MenuItem onClick={signout}>Logout</MenuItem>
            </Menu>

            {/* <NavDropdown className="mr-5" title={<span><Avatar style={{height:"30px", width:"30px"}}/></span>} id="basic-nav-dropdown" >
          <NavDropdown.Item href="/profile">Profile</NavDropdown.Item>
          <NavDropdown.Item href="/changepassword">Change Password</NavDropdown.Item>
          <NavDropdown.Item href="/orders">Orders</NavDropdown.Item>
          <NavDropdown.Item href="/subscription">Subscripation</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={signout}>Sign Out</NavDropdown.Item>
        </NavDropdown> */}
          </span>
        ) : (
          <span>
            {/* <Link to="/signin">         
            <Button  className="ml-2" variant="info">SIGN IN</Button>
            </Link>
            <Link to="/signup">
            <Button  className="ml-2" variant="info">SIGN UP</Button>
            </Link> */}
          </span>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Adminheader;
